import { PayLoadStruct } from "./class/providers/fccProvider";
import { payloadCodeTypeEnum } from "./dataStruct";
import { parseCss } from "./functions";

/** Keep AC masses/arms and apply the locally saved installation selection exactly once. */
export function selectInstalledEquipment(
  definitions: PayLoadStruct[],
  selections: PayLoadStruct[],
  mission: string
): PayLoadStruct[] {
  return definitions.filter((definition) => {
    const id = parseCss(definition.parameters, "equipmentId");
    const selected =
      id &&
      selections.find(
        (row) =>
          parseCss(row.parameters, "equipmentId") === id &&
          (!parseCss(row.parameters, "opsMissionType") || parseCss(row.parameters, "opsMissionType") === mission)
      );
    return selected ? selected.active : parseCss(definition.parameters, "default") !== "false";
  });
}

/** AC owns definitions; only the pilot's installation choice is restored from the duty. */
export function withAircraftEquipment(current: PayLoadStruct[], definitions: PayLoadStruct[]): PayLoadStruct[] {
  const isEquipment = (row: PayLoadStruct) =>
    [payloadCodeTypeEnum.equipment, payloadCodeTypeEnum.optionalEquipment].includes(Number(row.codeType));
  const result = current.filter((row) => !isEquipment(row));
  for (const definition of definitions) {
    const id = parseCss(definition.parameters, "equipmentId");
    const saved = current.find(
      (row) =>
        Number(row.codeType) === Number(definition.codeType) &&
        (id ? parseCss(row.parameters, "equipmentId") === id : row.name === definition.name)
    );
    const fixed = Number(definition.codeType) === payloadCodeTypeEnum.equipment;
    result.push(
      Object.assign(new PayLoadStruct(), definition, {
        description: definition.description || "",
        parameters: definition.parameters || "",
        unitLoad: 0,
        weightOrigValue: definition.weightValue,
        active: fixed || (saved ? saved.active : parseCss(definition.parameters, "default") !== "false"),
      })
    );
  }
  return result;
}
